module.exports = __webpack_public_path__ + "static/media/glyph-learn.64f949cc.svg";